import React from 'react';
import { useUserStore } from '../../hooks/zustand/user';
import EditionPage from './index';
import StudentEditionView from './StudentEditionView';

export default function EditionRouter() {
  const role = useUserStore((state) => state.user.role);

  if (role === 'student') {
    return <StudentEditionView />;
  }

  return <EditionPage />;
}
